/**
 *
 * MultiAutocomplete reducer
 *
 */

import { FormField } from 'domain/Data/recordTypes';
import { LOAD_ENTITIES_SUCCESS, LOAD_ENTITIES_ERROR } from 'domain/Data/constants';
import { CLEAR_OPTIONS, IS_INITIALIZED } from './constants';

function multiAutocompleteReducer(state = new FormField({}), { type, meta, payload }) {
  switch (type) {
    case IS_INITIALIZED:
      return state
        .setIn([meta.advancedForm, 'fields', meta.field, 'isInitialized'], true);

    case CLEAR_OPTIONS:
      return state
        .setIn([meta.advancedForm, 'fields', meta.field, 'loadedOptions'], [])
        .setIn([meta.advancedForm, 'fields', meta.field, 'loaded'], false);


    case LOAD_ENTITIES_SUCCESS:
      return state
        .setIn([meta.advancedForm, 'fields', meta.field, 'loadedOptions'], payload.entities.map((entity) => entity.id))
        .setIn([meta.advancedForm, 'fields', meta.field, 'loaded'], true);


    case LOAD_ENTITIES_ERROR:
      return state.setIn([meta.advancedForm, 'fields', meta.field, 'error'], 'Ошибка при загрузке списка значений');

    default:
      return state;
  }
}

export default multiAutocompleteReducer;
